import { CognitoUserPool, CognitoUser, AuthenticationDetails } from "amazon-cognito-identity-js";
import { cognitoConfig } from "../utils/cognitoConfig"; // Your Cognito configuration

const userPool = new CognitoUserPool(cognitoConfig);

export const authenticateUser = async (Username, Password) => {
  const user = new CognitoUser({ Username, Pool: userPool });
  const authDetails = new AuthenticationDetails({ Username, Password });
  //console.log(authDetails);

  return new Promise((resolve, reject) => {
    user.authenticateUser(authDetails, {
      onSuccess: (session) => {
        console.log(session);// Handle successful authentication
        //const idToken = session.getIdToken().getJwtToken();
        //const payLoad = session.getIdToken().decodePayload();//.getJwtToken();
        //const idToken = session.getIdToken().getJwtToken();
        //console.log(idToken)
        //console.log(payLoad)
        resolve(session);
        return session;


      },
      onFailure: (err) => {
        // Handle authentication failure
        //console.log(JSON.stringify(err));
        reject(err);
      },
      mfaRequired: function (codeDeliveryDetails) {
        // MFA is required to complete user authentication.
        // Get the code from user and call
        //user.sendMFACode(mfaCode, this)
      },

      newPasswordRequired: function (userAttributes, requiredAttributes) {
        // User was signed up by an admin and must provide new
        // password and required attributes, if any, to complete
        // authentication.

        // the api doesn't accept this field back
        //delete userAttributes.email_verified;

        // store userAttributes on global variable
        //sessionUserAttributes = userAttributes;
      }

    });
  });
};

export const logoutCognito = () => {
  const cognitoUser = userPool.getCurrentUser();

  if (cognitoUser) {
    cognitoUser.signOut();
  }
};

export const registerUser = async (newUser) => {
  // add the createdby user;
  // for email confirmation later
  const attributeList = [
    //{ Name: 'username', Value: email },
    // { Name: 'createdBy', Value: newUser.createdBy },
    { Name: 'given_name', Value: newUser.firstname },
    { Name: 'family_name', Value: newUser.lastname },
    { Name: 'email', Value: newUser.email} 

    // Add any other custom attributes you need
  ];
  // console.log("pass:",newUser.password);
  // console.log("dhsla" ,newUser.password,newUser.email, newUser.firstname, newUser.lastname);

  return new Promise((resolve, reject) => {
    userPool.signUp(newUser.email, newUser.password, attributeList, null, (error, data) => {
      if (error) {
        //console.log("Couldn't sign up");
        //console.log(error.message || JSON.stringify(error));
        reject(error);
        return (error);
      }
      else {
        //console.log("Sign up:",data);
        resolve(data)
      };
    })
  });
}

export const handleConfirmSignUp = async (email, confirmationCode) => {
  const user = new CognitoUser({
    Username: email,
    Pool: userPool,
  });

  return new Promise((resolve, reject) => {
    user.confirmRegistration(confirmationCode, true, (error, result) => {
      if (error) {
        reject(error);
      } else {
        resolve(result);
      }
    });
  });
};
export const handleForgetPassword = async (email) =>{
  const user = new CognitoUser({
    Username: email,
    Pool: userPool,
  });

  return new Promise((resolve, reject) => {
    user.forgotPassword({
      onSuccess: (data) => resolve(data),
      onFailure: (err) => reject(err),
    });
  });

}

export const handleConfirmNewPassword = async (email, verificationCode, newPassword) => {
  const user = new CognitoUser({
    Username: email,
    Pool: userPool,
  });

  return new Promise((resolve, reject) => {
    user.confirmPassword(verificationCode, newPassword, {
      onSuccess: (data) => resolve(data), 
      onFailure: (err) => reject(err), 
    });
  });
}
export default authenticateUser;